<div class="mat-table-container">
    <mat-table [dataSource]="platformKeys" class="mat-elevation-z8 mat-responsive-table">

      <ng-container matColumnDef="description">
  <mat-header-cell *matHeaderCellDef class="column">
    Description
  </mat-header-cell>

  <mat-cell *matCellDef="let element" class="column">
<a
  *ngIf="element.description"
  [href]="element.description"
  target="_blank"
  rel="noopener noreferrer"
>
      {{ element.description }}
    </a>

  </mat-cell>
</ng-container>

      <ng-container matColumnDef="platform">
        <mat-header-cell *matHeaderCellDef class="column">Platform</mat-header-cell>
        <mat-cell *matCellDef="let element" class="column" (dblclick)="startEdit(element)">
          <ng-container *ngIf="editedRow !== element; else editDropdown">
            {{ element.platform }}
          </ng-container>
          <ng-template #editDropdown>
            <select
              [(ngModel)]="element.platform"
            >
              <option *ngFor="let platform of platforms" [value]="platform">{{platform}}</option>
            </select>
          </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="storeIdentifier">
        <mat-header-cell *matHeaderCellDef class="column">Store Identifier</mat-header-cell>
        <mat-cell *matCellDef="let element" class="column" (dblclick)="startEdit(element)">
          <ng-container *ngIf="editedRow !== element; else editMode">
            {{ element.storeIdentifier }}
          </ng-container>
          <ng-template #editMode>
            <input
              style="border: solid black; text-align: left;"
              [(ngModel)]="element.storeIdentifier"
            />
          </ng-template>
        </mat-cell>
      </ng-container>
  
      <ng-container matColumnDef="accessKey">
        <mat-header-cell *matHeaderCellDef class="column"> Access Key </mat-header-cell>
        <mat-cell *matCellDef="let element" class="column">
          <input type="text" [value]="element.accessKey || '******'" readonly />
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="secretKey">
        <mat-header-cell *matHeaderCellDef class="column"> Secret Key </mat-header-cell>
        <mat-cell *matCellDef="let element" class="column">
          <input type="text" [value]="element.secretKey || '******'" readonly />
        </mat-cell>
      </ng-container>

  <ng-container matColumnDef="plugin">
  <mat-header-cell *matHeaderCellDef class="column">
    Plugin
  </mat-header-cell>

  <mat-cell *matCellDef="let element" class="column">
<a
  *ngIf="element.plugin"
  [href]="element.plugin"
  target="_blank"
  rel="noopener noreferrer"
  mat-button
  color="primary"
>
      Install Plugin
    </a>

  </mat-cell>
</ng-container>

      <ng-container matColumnDef="isVerified">
        <mat-header-cell *matHeaderCellDef class="column"> Status </mat-header-cell>
        <mat-cell *matCellDef="let element" class="column">
          {{element.isVerified ? 'Verified' : 'Unverified'}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="action">
  <mat-header-cell *matHeaderCellDef class="column action-header">
    Action
    <button mat-icon-button (click)="addKeys()">
      <mat-icon>add</mat-icon>
    </button>
  </mat-header-cell>

  <mat-cell *matCellDef="let element" class="column">
    <button mat-raised-button color="primary"
      [disabled]="element.isVerified"
      (click)="generateKey(element.platform, element)">
      Generate Key
    </button>
  </mat-cell>
</ng-container>

<ng-container matColumnDef="action2">
  <mat-header-cell *matHeaderCellDef class="column action2-header">
    Plugin Details
    <button mat-icon-button (click)="addKeys()">
      <mat-icon>add</mat-icon>
    </button>
  </mat-header-cell>

  <mat-cell *matCellDef="let element" class="column">
    <button mat-raised-button color="primary"
      [disabled]="element.isVerified"
      (click)="openPluginPopup(element.platform,element)">
      update plugin detail
    </button>
  </mat-cell>
</ng-container>
      <!-- <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef class="column"> Action <button mat-icon-button (click)="addKeys()"><mat-icon>add</mat-icon></button> </mat-header-cell>
        <mat-cell *matCellDef="let element" class="column">
          <button mat-raised-button color="primary" [disabled]="element.isVerified" (click)="generateKey(element.platform, element)">
            Generate Key
          </button>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="action2">
        <mat-header-cell *matHeaderCellDef class="column"> Action2 <button mat-icon-button (click)="addKeys()"><mat-icon>add</mat-icon></button> </mat-header-cell>
        <mat-cell *matCellDef="let element" class="column">
          <button mat-raised-button color="primary" [disabled]="element.isVerified" (click)="openPluginPopup(element.platform,element)">
           update plugin detail 
          </button>
        </mat-cell>
      </ng-container> -->
  
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
  </div>
  
<div
  class="plugin-popup-overlay"
  *ngIf="showPluginPopup"
>

  <div class="plugin-popup-box">

    <div class="plugin-popup-header">
      <h2>Update Plugin Details</h2>

      <button
        mat-icon-button
        (click)="closePluginPopup()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Description Link</mat-label>

      <input
        matInput
        [(ngModel)]="pluginForm.description"
        placeholder="Enter description link"
      >
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Plugin Link</mat-label>

      <input
        matInput
        [(ngModel)]="pluginForm.plugin"
        placeholder="Enter plugin link"
      >
    </mat-form-field>

    <div class="plugin-popup-actions">

      <button
        mat-raised-button
        color="primary"
        (click)="savePluginDetails()"
      >
        Save
      </button>

      <button
        mat-button
        (click)="closePluginPopup()"
      >
        Cancel
      </button>

    </div>

  </div>

</div>